export function reduceName(nomeCompleto) {
  const partes = nomeCompleto.trim().split(/\s+/);
  if (partes.length === 0) return "";

  const excecoes = ["da", "de", "do", "das", "dos"];

  if (partes.length >= 3 && excecoes.includes(partes[1].toLowerCase())) {
    return `${partes[0]} ${partes[1]} ${partes[2]}`;
  } else if (partes.length >= 2) {
    return `${partes[0]} ${partes[1]}`;
  } else {
    // Apenas o primeiro nome
    return partes[0];
  }
}